import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Pagination from './Pagination';

const AmbassadorDisplay = ({ searchQuery = '', selectedAmbassadors = [], onSelectionChange = () => {} }) => {
  const [ambassadors, setAmbassadors] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.junctionverse.com';

  const fetchAmbassadors = async (page = 1) => {
    try {
      setLoading(true);
      const params = {
        page,
        limit: 50,
      };

      // Add search query if provided
      if (searchQuery) {
        params.search = searchQuery;
      }

      const response = await axios.get(`${API_BASE_URL}/admin/ambassadors`, {
        params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      
      if (response.data.data && response.data.pagination) {
        setAmbassadors(response.data.data);
        setPagination(response.data.pagination);
      } else {
        setAmbassadors(Array.isArray(response.data) ? response.data : []);
        setPagination(null);
      }
    } catch (err) {
      console.error('Failed to fetch ambassadors:', err);
      // Check if it's an authentication error
      if (err.response?.status === 401 || err.response?.status === 403) {
        setError('Unauthorized: Please log in again');
        // Don't automatically logout - let the parent handle it if needed
      } else {
        setError(err.response?.data?.error || 'Failed to fetch ambassadors');
      }
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchAmbassadors(page);
  };

  // Fetch on mount and reset to page 1 when search changes
  useEffect(() => {
    setCurrentPage(1);
    fetchAmbassadors(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery]);

  // Note: Parent component should refresh by changing key prop instead of using onRefresh callback

  if (loading) return <p>Loading...</p>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;

  return (
    <div>
      <table style={{ width: '100%', marginTop: '20px', borderCollapse: 'collapse' }}>
        <thead style={{
          backgroundColor: 'rgb(250, 248, 255)',
          borderTop: '1px solid rgb(233, 230, 241)',
          borderBottom: '1px solid rgb(233, 230, 241)',
        }}>
          <tr className='link-row border-bottom'>
            <th className="p-3 text-center" style={{ width: '50px' }}>
              <input
                type="checkbox"
                checked={ambassadors.length > 0 && selectedAmbassadors.length === ambassadors.length}
                onChange={(e) => {
                  if (e.target.checked) {
                    onSelectionChange(ambassadors);
                  } else {
                    onSelectionChange([]);
                  }
                }}
              />
            </th>
            <th className="p-3 text-center">Full Name</th>
            <th className="p-3 text-center">Email</th>
            <th className="p-3 text-center">User Type</th>
            <th className="p-3 text-center">Verified</th>
            <th className="p-3 text-center">Onboarded</th>
            <th className="p-3 text-center">Created</th>
          </tr>
        </thead>
        <tbody>
          {ambassadors.length === 0 ? (
            <tr>
              <td colSpan="7" className="text-center p-3">No ambassadors found</td>
            </tr>
          ) : (
            ambassadors.map(ambassador => {
              const isSelected = selectedAmbassadors.some(a => a.id === ambassador.id);
              return (
              <tr key={ambassador.id} className={`link-row border-bottom ${isSelected ? 'table-active' : ''}`}>
                <td className="p-2 text-center">
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={(e) => {
                      if (e.target.checked) {
                        onSelectionChange([...selectedAmbassadors, ambassador]);
                      } else {
                        onSelectionChange(selectedAmbassadors.filter(a => a.id !== ambassador.id));
                      }
                    }}
                  />
                </td>
                <td className="p-2 text-center">{ambassador.fullName || 'N/A'}</td>
                <td className="p-2 text-center">{ambassador.email}</td>
                <td className="p-2 text-center">
                  <span className="badge bg-primary">
                    {ambassador.userType || 'N/A'}
                  </span>
                </td>
                <td className="p-2 text-center">
                  {ambassador.isVerified ? (
                    <span className="badge bg-success">Verified</span>
                  ) : (
                    <span className="badge bg-warning">Not Verified</span>
                  )}
                </td>
                <td className="p-2 text-center">
                  {ambassador.isOnboarded ? (
                    <span className="badge bg-success">Onboarded</span>
                  ) : (
                    <span className="badge bg-warning">Not Onboarded</span>
                  )}
                </td>
                <td className="p-2 text-center">
                  {new Date(ambassador.createdAt).toLocaleDateString()}
                </td>
              </tr>
            );
            })
          )}
        </tbody>
      </table>

      {pagination && (
        <Pagination
          currentPage={pagination.currentPage}
          totalPages={pagination.totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </div>
  );
};

export default AmbassadorDisplay;
